var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArmPowerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "armPowerIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 286",
    transform: "translate(36 48)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h100v100H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "armPowerIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 287",
    fill: "none",
    d: "M0 0h100v100H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36 -48)",
    clipPath: "url(#armPowerIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 48)",
    clipPath: "url(#armPowerIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 313",
    fill: "#040000"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 329",
    d: "M50.037 10.76c-13.81 0-25 10.951-25 24.462 0 8.815 3.942 17.763 11.39 21.485h27.221c7.448-3.722 11.39-12.67 11.39-21.485 0-13.51-11.191-24.462-25-24.462m0 39.742A15.761 15.761 0 1165.8 34.741 15.762 15.762 0 0150.037 50.5m0-29.746A13.985 13.985 0 1064.02 34.74a13.985 13.985 0 00-13.983-13.984"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 330",
    d: "M76.68 81.264l14.813-22.621-20.268-13.719 3.574-6 23.889 16.529a3.042 3.042 0 01.771 4.233l-.032.046L79.3 84.675 64.867 89.2a.76.76 0 01-.583-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 331",
    d: "M23.32 81.264L8.507 58.643l20.268-13.719-3.574-6L1.312 55.453a3.042 3.042 0 00-.771 4.233l.032.046L20.7 84.675l14.43 4.53a.76.76 0 00.583-1.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmPowerIcon);
export default __webpack_public_path__ + "static/media/armPowerIcon.4c96745232e1c0bf.svg";
export { ForwardRef as ReactComponent };